import SoundManager from "../../../../../../shared/lib/html5-software-library/src/ranj/audio/SoundManager";
import LanguagePack from "../../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import LayoutManager from "../../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import AppModel from "../../../../../../shared/src/ranj/app/core/AppModel";
import MediatorManager from "../../../../../../shared/src/ranj/app/core/MediatorManager";
import AbstractScreenMediator from "../../../../../../shared/src/ranj/app/ui/AbstractScreenMediator";
import SkinKeys from "../../../../../../shared/src/ranj/app/ui/SkinKeys";
import FeedbackPanelView from "../../feedback/FeedbackPanelView";
import InfoPanelMediator from "../../info-panel/InfoPanelMediator";
import GameModel from "../model/GameModel";

export default class AbstractCollaborationScreenMediator extends AbstractScreenMediator {

    /**
     * 
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {SoundManager} soundManager 
     * @param {*} gameAssets 
     * @param {GameModel} gameModel 
     * @param {MediatorManager} mediatorManager 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel, mediatorManager) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this._gameAssets = gameAssets;
        this._gameModel = gameModel;
        this._speedFactor = AppModel.speedFactor;
        this._mediatorManager = mediatorManager;

        if (ranj.DEBUG) {
            window.screen = this;
        }
    }

    destroy() {
        super.destroy();
        if (window.screen == this) {
            window.screen = null;
        }

        if(!!this._infoPanel){
            this._infoPanel.removeEventListener(InfoPanelMediator.CLOSE, this._handleInfoPanelClose.bind(this));
            this._infoPanel.removeEventListener(InfoPanelMediator.OPEN, this._handleInfoPanelOpen.bind(this));
            this._infoPanel.destroy();
        }
    }

    addInfoPanel() {
        const skin = new this._gameAssets.InfoPanelSkin();
        this._target.addChild(skin);
        /** @type {InfoPanelMediator} */
        this._infoPanel = this._mediatorManager.createMediator(skin, SkinKeys.INFO_SKIN);
        this._infoPanel.addEventListener(InfoPanelMediator.CLOSE, this._handleInfoPanelClose.bind(this));
        this._infoPanel.addEventListener(InfoPanelMediator.OPEN, this._handleInfoPanelOpen.bind(this));

        this.anchorObject(skin, Anchor.T);
    }

    showSavegameRestoredFeedback(y = -150) {
        const str = this.getText("savegame.restored");
        this.showFeedback(str, y);
    }
    
    showFeedback(str, y = -150) {
        const skin = new this._gameAssets.FeedbackPanel();
        skin.y = y;
        this._target.addChild(skin);
        const view = new FeedbackPanelView(skin);
        view.addEventListener(FeedbackPanelView.CLOSE, () => {
            this._target.removeChild(skin);
        });
        view.setText(str, true);
    }

    _handleInfoPanelClose(e) {

    }
    _handleInfoPanelOpen(e) {

    }


    _createFadeOverlay(isShown = false) {
        const shape = this._target.addChild(new createjs.Shape());
        const w = 2000, h = 4000;
        shape.alpha = isShown ? 1 : 0;
        shape.graphics.f(getComputedStyle(document.body).backgroundColor).r(-w / 2, -h / 2, w, h);
        this._fadeOverlay = shape;
        // NB: add click eater
        this._fadeOverlay.addEventListener("click", () => {});
    }

    _fadeIn(callback) {
        this._fade(1, 0, callback);
    }

    _fadeOut(callback) {
        this._fade(0, 1, callback);
    }

    _fade(from, to, callback) {
        if (!this._fadeOverlay) {
            this._createFadeOverlay();
        }
        this._fadeOverlay.visible = true;
        this._fadeOverlay.alpha = from;
        const tween = createjs.Tween.get(this._fadeOverlay)
            .to({ alpha: to }, 700 / this._speedFactor, createjs.Ease.quadIn)
            .wait(700 / this._speedFactor);
        if (callback != null) {
            tween.call(callback);
        }
    }
}
